// Global UI helpers (snackbar, modals, confirmations)

"use strict";

import { AppEvents, type SnackBarOptions } from "@/control/app-events";

/**
 * Shows a transient message in the global snackbar.
 * @param msg Message text
 * @param position Optional horizontal position
 */
export function showSnackBar(msg: string, position?: "left" | "center" | "right"): void;
/**
 * Shows a transient message in the global snackbar.
 * @param options SnackBarOptions object
 */
export function showSnackBar(options: SnackBarOptions): void;
export function showSnackBar(msgOrOptions: string | SnackBarOptions, position?: "left" | "center" | "right"): void {
    if (typeof msgOrOptions === "string") {
        AppEvents.Emit("snack", { message: msgOrOptions, position });
    } else {
        AppEvents.Emit("snack", msgOrOptions);
    }
}

/**
 * Opens the global message modal.
 * @param title Modal title
 * @param msg Modal body text
 */
export function showMessageModal(title: string, msg: string): void {
    AppEvents.Emit("msg-modal", title, msg);
}

/**
 * Opens the global confirmation modal and runs a callback on confirm.
 * @param options Confirmation title, message, optional danger style, and confirm callback
 */
export function askUserConfirmation(options: { title: string; message: string; danger?: boolean; callback: () => void }): void {
    AppEvents.Emit("ask-confirmation", options);
}

/**
 * Opens the global profile modal for a user.
 * @param uid User identifier to display
 */
export function showProfileModal(uid: string): void {
    AppEvents.Emit("show-profile", uid);
}

/**
 * Composable that exposes global UI actions (snackbar, modals, confirmations).
 */
export function useAppUi() {
    return {
        showSnackBar,
        showMessageModal,
        askUserConfirmation,
        showProfileModal,
    };
}
